/* Homepage community reel, 16/10/2026 (Justyn): a sound on/off button on the playing clip, and a tap on the
   playing clip opens an Instagram Reels style player, the same behaviour as the product-page video pop-up on Halo
   (pdp-redesign.js): full screen on phones, a centred 9:16 player on desktop, progress bars that fill as each
   clip plays, sound on, tap the left third to go back, the right third to skip, the middle to pause, swipe up for
   the next clip, down for the previous one (or to close on the first), arrow keys and Escape.
   hr-ugc.js builds the endless rail (it clones the clips) and plays the centred one; this file only adds to it.
   16/10 later: the reel's previews play once and then move on, everything pauses off screen, and the player plays each
   clip's full video (data-full, else the ~30s cut data-player) from the beginning, sales ending cut off. */
(function () {
  if (window.__hrReels) return;
  window.__hrReels = true;

  var ICON_MUTE = '<svg width="18" height="18" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3 6V10H6L10 13V3L6 6H3Z" fill="currentColor"/><path d="M12 6L14 8M14 8L12 10M14 8L12 6" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>';
  var ICON_SOUND = '<svg width="18" height="18" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3 6V10H6L10 13V3L6 6H3Z" fill="currentColor"/><path d="M12 5.5C12.8 6.3 12.8 9.7 12 10.5M13.5 4C15 5.5 15 10.5 13.5 12" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>';

  function setup(rail) {
    if (rail.__hrReels) return;
    var all = [].slice.call(rail.querySelectorAll('.ugc__item'));
    var base = all.filter(function (el) { return !el.dataset.clone; });
    /* hr-ugc.js has not cloned the set yet: try again shortly */
    if (base.length && all.length === base.length && !rail.__hrReelsWait) {
      rail.__hrReelsWait = true;
      setTimeout(function () { setup(rail); }, 120);
      return;
    }
    rail.__hrReels = true;
    var n = base.length;
    if (!n) return;
    var section = rail.closest('section') || rail;

    /* ---------- sound on the reel ---------- */
    var soundOn = false, reelsOpen = false;
    var activeItem = function () { return rail.querySelector('.ugc__item.is-active'); };
    var activeVideo = function () { var it = activeItem(); return it && it.querySelector('video'); };
    var paintSound = function () {
      section.classList.toggle('ugc-sound-on', soundOn);
      [].forEach.call(rail.querySelectorAll('[data-hr-ugc-sound]'), function (b) {
        b.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
        b.setAttribute('aria-label', soundOn ? 'Turn sound off' : 'Turn sound on');
      });
    };
    var applySound = function () {
      [].forEach.call(rail.querySelectorAll('video'), function (v) { v.muted = !soundOn; });
      paintSound();
    };
    /* every clip the rail starts follows the visitor's choice */
    rail.addEventListener('play', function (e) { if (e.target.tagName === 'VIDEO') e.target.muted = !soundOn; }, true);

    /* off screen the reel stops: nothing plays, or makes a sound, once it has scrolled out of view (Justyn 16/10) */
    /* measured on demand (an observer alone can lag behind a fast scroll); at least a fifth of the reel must show */
    var visible = function () {
      var r = rail.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight;
      return Math.min(r.bottom, vh) - Math.max(r.top, 0) > r.height * 0.2;
    };
    var pauseAll = function () { [].forEach.call(rail.querySelectorAll('video'), function (v) { if (!v.paused) v.pause(); }); };
    rail.addEventListener('play', function (e) {
      if (e.target.tagName === 'VIDEO' && (reelsOpen || !visible())) e.target.pause();
    }, true);
    var wasVisible = null;
    var checkVisible = function () {
      var now = visible();
      if (now === wasVisible) return;
      wasVisible = now;
      if (!now) pauseAll();
      else if (!reelsOpen) { var v = activeVideo(); if (v && v.getAttribute('src')) v.play().catch(function () {}); }
    };
    /* 19/10: the observer already reports when the reel comes into or out of view; the scroll timer (which
       re-measured the reel every 150ms while scrolling and made phones stutter) is only kept for old browsers */
    if ('IntersectionObserver' in window) new IntersectionObserver(checkVisible, { threshold: [0, 0.2, 0.5] }).observe(rail);
    else window.addEventListener('scroll', function () { if (!checkVisible.t) checkVisible.t = setTimeout(function () { checkVisible.t = 0; checkVisible(); }, 150); }, { passive: true });

    /* a clip with no quote (e.g. the design's Elite and Infra Pod footage) clears the quote line rather than
       leaving the previous creator's words under it; hr-ugc.js only writes a quote when there is one */
    var qFig = section.querySelector('[data-hr-ugc-quote]');
    if (qFig && 'MutationObserver' in window) {
      new MutationObserver(function (ms) {
        ms.forEach(function (m) {
          var it = m.target;
          if (!it.classList.contains('is-active') || it.dataset.quote) return;
          setTimeout(function () {
            if (!it.classList.contains('is-active')) return;
            var q = qFig.querySelector('[data-hr-ugc-q]'), b = qFig.querySelector('[data-hr-ugc-by]');
            if (q) q.textContent = '';
            if (b) b.textContent = '';
          }, 320);
        });
      }).observe(rail, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    /* 16/10 (Justyn "use the same font" as the press quote): words wrapped in *stars* in a clip's quote are
       shown dark, the rest light grey. hr-ugc.js writes plain text, so turn the stars into <em> after it does */
    var qText = section.querySelector('[data-hr-ugc-q]');
    if (qText && 'MutationObserver' in window) {
      var esc = function (s) { return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
      var mark = function () {
        var t = qText.textContent;
        if (t.indexOf('*') < 0) return;
        qText.innerHTML = t.split('*').map(function (part, i) { return i % 2 ? '<em>' + esc(part) + '</em>' : esc(part); }).join('');
      };
      new MutationObserver(mark).observe(qText, { childList: true, characterData: true, subtree: true });
      mark();
    }

    /* previews play once, then the reel moves on to the next clip by itself */
    [].forEach.call(rail.querySelectorAll('video'), function (v) { v.loop = false; v.removeAttribute('loop'); });
    var nextBtn = section.querySelector('[data-hr-next]');
    rail.addEventListener('ended', function (e) {
      var v = e.target;
      if (v.tagName !== 'VIDEO' || reelsOpen || !visible()) return;
      var it = v.closest('.ugc__item');
      if (!it || !it.classList.contains('is-active')) return;
      /* not while the visitor is swiping: try again once the reel is still */
      var go = function () {
        if (reelsOpen || !it.classList.contains('is-active') || !visible()) return;
        if (rail.__hrBusy && rail.__hrBusy()) { setTimeout(go, 400); return; }
        if (nextBtn) nextBtn.click(); else { v.currentTime = 0; v.play().catch(function () {}); }
      };
      go();
    }, true);
    /* a phone may refuse to start the next clip with sound without a fresh tap: fall back to silent so it never sits frozen */
    var keepPlaying = function () {
      if (!soundOn || reelsOpen || !visible()) return;
      var v = activeVideo();
      if (!v || !v.getAttribute('src') || !v.paused || v.__hrUserPaused) return;
      var r = rail.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      var p = v.play();
      if (p && p.catch) p.catch(function () { soundOn = false; applySound(); v.play().catch(function () {}); });
    };
    setInterval(keepPlaying, 700);

    rail.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-hr-ugc-sound]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      soundOn = !soundOn;
      applySound();
      var v = btn.closest('.ugc__item').querySelector('video');
      if (v && soundOn) {
        if (!v.getAttribute('src') && v.dataset.src) v.src = v.dataset.src;
        var p = v.play();
        if (p && p.catch) p.catch(function () { soundOn = false; applySound(); });
      }
    }, true);

    /* ---------- tap the playing clip: open the Reels player ---------- */
    var downX = 0, downY = 0, moved = false;
    rail.addEventListener('pointerdown', function (e) { downX = e.clientX; downY = e.clientY; moved = false; }, { passive: true });
    rail.addEventListener('pointermove', function (e) {
      if (Math.abs(e.clientX - downX) > 8 || Math.abs(e.clientY - downY) > 8) moved = true;
    }, { passive: true });
    rail.addEventListener('click', function (e) {
      if (e.target.closest('[data-hr-ugc-sound]') || e.target.closest('.ugc__card')) return;
      var tile = e.target.closest('.ugc__tile');
      if (!tile || moved) return;
      var item = tile.closest('.ugc__item');
      /* a tap on a side clip only brings it to the centre (hr-ugc.js) */
      if (!item.classList.contains('is-active')) return;
      var k = [].indexOf.call(rail.querySelectorAll('.ugc__item'), item);
      /* the player starts the clip again from the beginning and plays it all the way through (Justyn 16/10) */
      open(k < 0 ? 0 : k % n);
    });
    rail.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var tile = e.target.closest('.ugc__tile');
      if (!tile) return;
      var item = tile.closest('.ugc__item');
      if (!item.classList.contains('is-active')) return;
      e.preventDefault();
      open(Math.max(0, [].indexOf.call(rail.querySelectorAll('.ugc__item'), item)) % n);
    });

    var clips = base.map(function (el) {
      var v = el.querySelector('video'), card = el.querySelector('.ugc__card');
      var thumb = el.querySelector('.ugc__thumb img');
      return {
        src: el.dataset.player || (v && (v.dataset.src || v.getAttribute('src'))) || '',
        full: el.dataset.full || '',
        hd: el.dataset.fullHd || '',
        poster: (v && (v.dataset.poster || v.getAttribute('poster'))) || '',
        label: (el.querySelector('.ugc__tag') || {}).textContent || '',
        by: el.dataset.by || '',
        url: card ? card.getAttribute('href') : '',
        name: card ? ((card.querySelector('.n') || {}).textContent || '') : '',
        price: card ? ((card.querySelector('.p') || {}).textContent || '') : '',
        thumb: thumb ? thumb.getAttribute('src') : ''
      };
    }).filter(function (c) { return c.src; });
    if (!clips.length) return;

    /* ---------- the player (built once, on <body> so it sits above the fixed site header) ---------- */
    var modal = document.createElement('div');
    modal.className = 'hrr';
    modal.hidden = true;
    /* back / next / close sit together over the video's top-right corner (Justyn 16/10); phones swipe instead of
       using back and next, so only close shows there */
    modal.innerHTML =
      '<div class="hrr__backdrop" data-hrr-close></div>' +
      '<div class="hrr__dialog" role="dialog" aria-modal="true" aria-label="Community videos">' +
        '<div class="hrr__progress"></div>' +
        '<div class="hrr__controls"><button type="button" class="hrr__control" data-hrr-mute aria-label="Mute or unmute video"><span class="hrr__icon-mute">' + ICON_MUTE + '</span><span class="hrr__icon-unmute">' + ICON_SOUND + '</span></button></div>' +
        '<div class="hrr__tr">' +
          '<span class="hrr__nav">' +
            '<button type="button" class="hrr__btn" data-hrr-prev aria-label="Previous video"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
            '<button type="button" class="hrr__btn" data-hrr-next aria-label="Next video"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
          '</span>' +
          '<button type="button" class="hrr__btn hrr__close" data-hrr-close aria-label="Close video"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
        '</div>' +
        '<div class="hrr__media"></div>' +
        '<span class="hrr__paused" aria-hidden="true"><svg width="26" height="30" viewBox="0 0 12 14" fill="none"><path d="M2 1.5L11 7L2 12.5V1.5Z" fill="white"/></svg></span>' +
        '<a class="hrr__card" href="#"><img class="hrr__thumb" alt="" width="48" height="48"><span class="hrr__meta"><span class="hrr__by"></span><span class="hrr__name"></span><span class="hrr__price"></span></span><span class="hrr__shop">Shop</span></a>' +
      '</div>';
    document.body.appendChild(modal);

    var media = modal.querySelector('.hrr__media');
    var progress = modal.querySelector('.hrr__progress');
    var card = modal.querySelector('.hrr__card');
    var cur = 0, frame = 0, modalSoundOff = false, swipedAt = 0, opener = null;

    var lock = function (on) { document.documentElement.classList.toggle('hrr-lock', on); };
    /* 17/10: stop, silence and unload the player's videos before they are removed, so an iPhone never keeps one
       playing (or holding a video slot) after the visitor moves to the next clip or closes the player */
    var clearMedia = function () {
      [].forEach.call(media.querySelectorAll('video'), function (v) {
        v.pause(); v.muted = true; v.removeAttribute('src'); v.load();
      });
      media.innerHTML = '';
    };

    /* 17/10 (Justyn "sharper, like Instagram Reels"): the player starts on the small cut so it plays at once. Once that
       has 5 seconds in hand, the 1080x1920 copy of the same cut loads underneath and takes over at the same moment when
       enough of it has arrived. If the small cut stalls first, the sharp copy is dropped; if the sharp copy stalls for
       over a second and a half, the small cut takes back over. Data saver and 2G never load the sharp copy */
    var stepUpOk = function () {
      var cn = navigator.connection || {};
      return !cn.saveData && !/(^|-)2g$/.test(cn.effectiveType || '');
    };
    var playing = function () { return media.querySelector('video.is-on') || media.querySelector('video'); };
    function stepUp(v, src, k, onEnd) {
      var hd = document.createElement('video');
      hd.className = 'hrr__hd';
      hd.preload = 'auto';
      hd.playsInline = true;
      hd.setAttribute('playsinline', '');
      hd.muted = true;
      hd.loop = v.loop;
      media.appendChild(hd);
      /* an iPhone lets an element play with sound later only if it was started during a tap: start and stop the sharp
         copy now (show() runs inside the tap that opened the player), before it has anything to load */
      try { var bp = hd.play(); if (bp && bp.catch) bp.catch(function () {}); hd.pause(); } catch (e) {}
      var started = false, done = false, stallT = 0;
      var here = function () { return reelsOpen && cur === k && hd.parentNode === media; };
      var drop = function () { done = true; hd.removeAttribute('src'); hd.load(); hd.remove(); };
      var ahead = function () { var b = v.buffered; return b.length ? b.end(b.length - 1) - v.currentTime : 0; };
      /* only on a connection that brings the small cut in at least 4.5 times faster than it plays (about 4 Mbps and up),
         and once it has 5 seconds in hand, so the sharp copy never takes bandwidth the small cut needs */
      var t0 = Date.now();
      var begin = function () {
        if (started || !here()) return;
        var b = v.buffered, end = b.length ? b.end(b.length - 1) : 0, secs = (Date.now() - t0) / 1000;
        var fast = end / Math.max(secs, 0.25) >= 4.5 || (v.duration && end >= v.duration - 0.5);
        if (fast && (ahead() >= 5 || (v.duration && ahead() >= v.duration - v.currentTime - 0.5))) { started = true; hd.src = src; }
      };
      /* hand the picture (and sound) from one copy to the other at the same moment: the new copy waits, paused and ready,
         a little ahead of the playing one, and starts the instant the playing one reaches that point */
      var hand = function (from, to, tries, failed) {
        tries = tries || 0;
        var lead = 0.8 + tries * 1.2;
        var target = Math.min(from.currentTime + lead, (to.duration || from.duration || 1e9) - 0.2);
        to.pause();
        to.currentTime = target;
        to.addEventListener('seeked', function () {
          if (!here()) return;
          if (from.currentTime > target - 0.05 && !from.paused) {
            if (tries < 2) hand(from, to, tries + 1, failed); else if (failed) failed();
            return;
          }
          var wait = function () {
            if (!here()) return;
            if (from.paused && !from.ended) { from.addEventListener('play', wait, { once: true }); return; }
            if (from.currentTime < target - 0.03) { requestAnimationFrame(wait); return; }
            /* the new copy takes over only once it is really playing; if the phone refuses, the old one carries on */
            to.muted = from.muted;
            var flip = function () {
              if (!here()) return;
              to.classList.add('is-on');
              from.classList.remove('is-on');
              from.muted = true;
              from.pause();
            };
            var p = to.play();
            if (p && p.then) p.then(flip, function () { to.pause(); to.muted = true; if (failed) failed(); });
            else flip();
          };
          wait();
        }, { once: true });
      };
      var swap = function () {
        if (done || !started || !here() || v.paused || hd.readyState < 3) return;
        done = true;
        hand(v, hd, 0, drop);
      };
      v.addEventListener('progress', begin);
      v.addEventListener('timeupdate', begin);
      v.addEventListener('waiting', function () { if (started && !done && here()) drop(); });
      hd.addEventListener('canplaythrough', swap);
      hd.addEventListener('progress', swap);
      v.addEventListener('play', swap);
      hd.addEventListener('waiting', function () {
        clearTimeout(stallT);
        stallT = setTimeout(function () {
          if (!here() || !hd.classList.contains('is-on') || hd.readyState >= 3) return;
          /* the sharp copy is stuck: the small cut carries on from the same moment straight away */
          v.currentTime = hd.currentTime;
          v.muted = hd.muted;
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
          v.classList.add('is-on');
          hd.classList.remove('is-on');
          hd.muted = true;
          hd.pause();
          setTimeout(function () { if (here() && v.classList.contains('is-on')) drop(); }, 400);
        }, 1500);
      });
      hd.addEventListener('playing', function () { clearTimeout(stallT); });
      hd.addEventListener('error', function () { if (!hd.classList.contains('is-on')) drop(); }, { once: true });
      if (onEnd) hd.addEventListener('ended', function () { if (hd.classList.contains('is-on')) onEnd(); }, { once: true });
      begin();
    }

    function show(k) {
      var total = clips.length;
      cur = ((k % total) + total) % total;
      var c = clips[cur];
      modal.classList.remove('is-paused', 'is-ready', 'is-unmuted');
      clearMedia();
      /* opening is a tap, which browsers accept as permission for sound; a visitor who mutes keeps it off */
      var withSound = !modalSoundOff;
      var v = document.createElement('video');
      /* the player plays the whole clip (Justyn 16/10: no short/full switch); the ~30s cut is only a fallback */
      v.src = c.full || c.src;
      v.className = 'is-on';
      if (c.poster) v.poster = c.poster;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.muted = !withSound;
      if (withSound) modal.classList.add('is-unmuted');
      v.loop = total < 2;
      media.appendChild(v);
      if (total > 1) v.addEventListener('ended', function () { if (v.classList.contains('is-on')) show(cur + 1); }, { once: true });
      if (c.hd && stepUpOk()) stepUp(v, c.hd, cur, total > 1 ? function () { show(cur + 1); } : null);
      /* 17/10 (Justyn, iPhone: "this video doesn't play first time"): play() is called straight away, inside the tap that
         opened the player, because an iPhone only allows sound when play() comes from the tap itself; waiting for the
         first frame made it refuse. If it still refuses, the clip plays silently rather than sitting on a still frame */
      var start = function () {
        var p = v.play();
        if (p && p.catch) p.catch(function () {
          if (!v.classList.contains('is-on')) return;
          if (v.muted) return;
          v.muted = true;
          modal.classList.remove('is-unmuted');
          v.play().catch(function () {});
        });
      };
      start();
      var reveal = function () {
        if (modal.classList.contains('is-ready')) return;
        modal.classList.add('is-ready');
        if (v.paused && v.classList.contains('is-on') && !modal.classList.contains('is-paused')) start();
      };
      if (v.readyState >= 2) reveal(); else { v.addEventListener('loadeddata', reveal, { once: true }); setTimeout(reveal, 2500); }

      progress.innerHTML = '';
      progress.hidden = total < 2;
      for (var i = 0; i < total; i++) {
        var bar = document.createElement('button');
        bar.type = 'button';
        bar.setAttribute('aria-label', 'Go to video ' + (i + 1));
        bar.appendChild(document.createElement('i'));
        if (i === cur) bar.classList.add('is-active');
        if (i < cur) bar.classList.add('is-done');
        (function (j) { bar.addEventListener('click', function (e) { e.stopPropagation(); show(j); }); })(i);
        progress.appendChild(bar);
      }
      cancelAnimationFrame(frame);
      var fill = progress.querySelector('button.is-active i');
      if (fill) {
        var tick = function () {
          var pv = playing();
          if (pv && pv.duration) fill.style.width = Math.min(100, (pv.currentTime / pv.duration) * 100) + '%';
          frame = requestAnimationFrame(tick);
        };
        tick();
      }
      modal.querySelector('.hrr__nav').hidden = total < 2;

      if (c.url) {
        card.hidden = false;
        card.href = c.url;
        var th = card.querySelector('.hrr__thumb');
        if (c.thumb) { th.src = c.thumb; th.hidden = false; } else th.hidden = true;
        card.querySelector('.hrr__by').textContent = c.by;
        card.querySelector('.hrr__name').textContent = c.name.trim();
        card.querySelector('.hrr__price').textContent = c.price.trim();
      } else card.hidden = true;
    }

    function open(k) {
      opener = document.activeElement;
      var rv = activeVideo();
      if (rv && !rv.paused) rv.pause();
      reelsOpen = true;
      modal.hidden = false;
      lock(true);
      show(k);
      var closeBtn = modal.querySelector('.hrr__close');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }
    function close() {
      if (!reelsOpen) return;
      reelsOpen = false;
      cancelAnimationFrame(frame);
      modal.hidden = true;
      clearMedia();
      lock(false);
      var rv = activeVideo();
      if (rv && rv.getAttribute('src')) { rv.muted = !soundOn; rv.play().catch(function () {}); }
      if (opener && opener.focus) opener.focus({ preventScroll: true });
    }
    function togglePlay() {
      var v = playing();
      if (!v) return;
      if (v.paused) v.play().catch(function () {}); else v.pause();
      modal.classList.toggle('is-paused', v.paused);
    }

    [].forEach.call(modal.querySelectorAll('[data-hrr-close]'), function (b) { b.addEventListener('click', close); });
    modal.querySelector('[data-hrr-prev]').addEventListener('click', function () { show(cur - 1); });
    modal.querySelector('[data-hrr-next]').addEventListener('click', function () { show(cur + 1); });
    modal.querySelector('[data-hrr-mute]').addEventListener('click', function (e) {
      e.stopPropagation();
      var v = playing();
      if (!v) return;
      v.muted = !v.muted;
      modal.classList.toggle('is-unmuted', !v.muted);
      modalSoundOff = v.muted;
      if (v.paused) v.play().catch(function () {});
    });
    card.addEventListener('click', function (e) { e.stopPropagation(); });

    media.addEventListener('click', function (e) {
      if (Date.now() - swipedAt < 400) return;
      var r = media.getBoundingClientRect();
      var x = r.width ? (e.clientX - r.left) / r.width : 0.5;
      if (clips.length > 1 && x < 0.3) show(cur - 1);
      else if (clips.length > 1 && x > 0.7) show(cur + 1);
      else togglePlay();
    });
    var dialog = modal.querySelector('.hrr__dialog');
    var tx = null, ty = null;
    dialog.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; }, { passive: true });
    dialog.addEventListener('touchend', function (e) {
      if (ty === null) return;
      var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty;
      tx = ty = null;
      if (Math.abs(dy) < 60 || Math.abs(dy) < Math.abs(dx)) return;
      swipedAt = Date.now();
      if (dy < 0) show(cur + 1);
      else if (cur > 0) show(cur - 1);
      else close();
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (!reelsOpen) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') show(cur + 1);
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') show(cur - 1);
      else if (e.key === ' ') { e.preventDefault(); togglePlay(); }
    });
  }

  function init() { [].forEach.call(document.querySelectorAll('.hr [data-hr-ugc]'), setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 0); });
  else setTimeout(init, 0);
  /* theme editor: sections re-render */
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });
})();
